import React from 'react';
import { motion } from 'framer-motion';

const Purposesection = () => {
  // Text animation variants for the title and description
  const titleVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  const descriptionVariant = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, delay: 0.3 } },
  };


  // Animation for floating bubbles or particles
  const particleVariant = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { 
      opacity: 1, 
      scale: 1.5, 
      x: ['-100px', '100px'], // Horizontal floating effect
      y: ['-100px', '100px'], // Vertical floating effect
      transition: { 
        repeat: Infinity, 
        repeatType: 'loop', 
        duration: 10, 
        ease: 'easeInOut' 
      },
    },
  };

  return (
    <section className="relative py-16 px-6 md:px-16 overflow-hidden bg-cover bg-center flex items-center justify-center"
             style={{ backgroundImage: "url('/path/to/your/background-image.jpg')" }}>
      {/* Gradient overlay to make the text more readable */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent z-10"></div>

      <motion.div
        className="max-w-3xl text-center relative z-20"
        initial="hidden"
        animate="visible"
      >
        {/* Title with animation */}
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-green-100 hover:text-green-500 text-center transition duration-300 mb-6"
          variants={titleVariant}
        >
          Our Purpose
        </motion.h2>

        {/* Description with animation */}
        <motion.p
          className="mt-4 text-lg md:text-xl text-gray-100 max-w-2xl mx-auto leading-relaxed"
          variants={descriptionVariant}
        >
          Cultivating excellence in every bud, Beyond Bloom is dedicated to providing premium small-batch craft cannabis to our partners.
        </motion.p>
      </motion.div>

    

      {/* Floating Bubbles/Particles */}
      <motion.div
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10"
        variants={particleVariant}
        initial="hidden"
        animate="visible"
      >
        <div className="w-12 h-12 bg-blue-200 rounded-full opacity-50"></div>
      </motion.div>

      <motion.div
        className="absolute top-3/4 left-1/4 transform -translate-x-1/2 -translate-y-1/2 z-10"
        variants={particleVariant}
        initial="hidden"
        animate="visible"
      >
        <div className="w-12 h-12 bg-blue-300 rounded-full opacity-50"></div>
      </motion.div>

      
      
    </section>
  );
};

export default Purposesection;
